import { Component, Input, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { BenefitByCategories } from 'src/app/home/models/categories.interface';

@Component({
  selector: 'app-table-plan',
  templateUrl: './table-plan.component.html',
  styleUrls: ['./table-plan.component.scss'],
})
export class TablePlanComponent implements OnInit {
  constructor(
    private active_router: ActivatedRoute
  ) {}
  @Input() recommendedPlan = '';
  benefitByCategories!: BenefitByCategories[];
  detail_plans!: any;
  planNames: string[] = [];
  visiblePlanIndices: number[] = [];

  async ngOnInit(): Promise<void> {
    this.detail_plans = this.active_router.snapshot.data['resolver_detail_plans'] ?? [];
     this.extractPlanNames();
  }
  

  extractPlanNames(): void {
    const firstBenefit = this.detail_plans?.[0];
    if (firstBenefit?.detalle_plan?.length > 0) {
      const allNames: string[] = firstBenefit.detalle_plan.map((p: any) => p.nombre_plan);
      this.visiblePlanIndices = allNames
        .map((name, i) => ({ name, i }))
        .filter(({ name }) => name != "")
        .map(({ i }) => i);
      this.planNames = this.visiblePlanIndices.map(i => allNames[i]);
    }
  }

  getVisibleDetallePlan(detalle_plan: any[]): any[] {
    const visible = this.visiblePlanIndices.map(i => detalle_plan[i]).filter(d => d !== undefined);
    return visible 
  }
 

  isRecommendedPlan(planName: string): boolean {
    return this.normalizePlanName(planName) === this.normalizePlanName(this.recommendedPlan);
  }

  private normalizePlanName(planName: string): string {
    return (planName || '')
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '')
      .trim()
      .toLowerCase();
  }
}
